// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__ZdhQY","title":"AfterBackImages_title__2KL-v","images":"AfterBackImages_images__2uIW-"};